export default __webpack_public_path__ + "images/SpeakersPhotos/Foto cesar mariel.jpg?5a27b14c";